import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import { ButtonGroup as BaseButtonGroup } from 'reactstrap'

import bindActionCreators from '../../../../lib/utils/bindActionCreators'

import Button from '../../../../lib/components/Button'

import { setValue } from '../actions'
import { getValue, getActual } from '../selectors'

/**
 * @typedef {import('../model').ValueType} ValueType
 */

const ButtonGroup = styled(BaseButtonGroup)`
  background-color: #fff;

  ${Button} {
    width: 72px;
    height: 30px;
    padding: 0;

    justify-content: center;
  }
`

/**
 * @typedef {object} Props
 * @property {boolean} actual
 * @property {ValueType} value
 * @property {typeof setValue} setValue
 */

/** @extends {Component<Props, *>} */
export class ValueTab extends Component {
  /** @type {Props} */
  static defaultProps = {
    value: 'standard',
    setValue: () => {},
  }

  /** @type {(value: ValueType) => () => void} */
  changeActive = value => () => this.props.setValue(value)

  render = () => {
    const { value, actual } = this.props
    return (
      <ButtonGroup>
        <Button
          color="danger"
          outline={ value !== 'standard' }
          onClick={ this.changeActive('standard') }
        >
          Std
        </Button>
        {actual && (
          <Button
            color="danger"
            outline={ value !== 'actual' }
            onClick={ this.changeActive('actual') }
          >
            Actual
          </Button>
        )}
      </ButtonGroup>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  value: getValue,
  actual: getActual,
})

const mapDispatchToProps = bindActionCreators({
  setValue,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ValueTab)



// WEBPACK FOOTER //
// ./src/pages/report/project-profit-sheet/components/ValueTab.jsx